let instanceName = null;
let showPayerName = false;
let companion = false;

const getDefaults = () => {
    // set defaults object
    const defaults = {
        agency_guid: process.env.VUE_APP_DEFAULT_REGION_ID,
        entities: [process.env.VUE_APP_DEFAULT_ENTITY_ID],
        primary_staff_id: process.env.VUE_APP_DEFAULT_STAFF_ID,
        staff: [process.env.VUE_APP_DEFAULT_STAFF_ID],
        teams: [process.env.VUE_APP_DEFAULT_TEAM_ID],
        groups: [process.env.VUE_APP_DEFAULT_GROUP_ID],
        level_of_care: [],
        etherapy_program: null,
        address: '',
        city: '',
        state: '',
        home_phone: '',
        is_activated: true,
        start_date: new Date()
    }

    if (process.env.NODE_ENV === 'production') {
        // get url identifier for specific region
        let name = window.location.hostname.split('.')[1];
        let dateString = `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`;
        let levelOfCare = [{id: 2, start_date: dateString, end_date: null, is_current: true}];
        switch (name) {
            case 'hbff':
                defaults.agency_guid = 'KE_eyZa';
                defaults.entities = [45];
                defaults.primary_staff_id = 2362;
                defaults.staff = [2362];
                defaults.groups = [72];
                defaults.teams = [6];
                instanceName = 'Available to Hazelden Betty Ford Members';
                break;
            case 'unicare':
                defaults.agency_guid = 'KP_gWNX';
                defaults.entities = [1];
                defaults.primary_staff_id = 1363;
                defaults.staff = [1363];
                defaults.groups = [];
                defaults.teams = [6];
                defaults.level_of_care = levelOfCare;
                defaults.etherapy_program = 2;
                instanceName = 'Available to Anthem WV Members';
                break;
            case 'amerigroup-tn':
                defaults.agency_guid = 'KP_gWNX';
                defaults.entities = [2];
                defaults.primary_staff_id = 1363;
                defaults.staff = [1363];
                defaults.groups = [];
                defaults.teams = [6];
                defaults.level_of_care = levelOfCare;
                defaults.etherapy_program = 2;
                instanceName = 'Available to Anthem TN Members';
                break;
            case 'healthyblue-nc':
                defaults.agency_guid = 'KP_gWNX';
                defaults.entities = [7];
                defaults.primary_staff_id = 1363;
                defaults.staff = [1363];
                defaults.groups = [];
                defaults.teams = [6];
                defaults.level_of_care = levelOfCare;
                defaults.etherapy_program = 2;
                instanceName = 'Available to Anthem NC Members';
                break;
            case 'anthem-ky':
                defaults.agency_guid = 'KP_gWNX';
                defaults.entities = [5];
                defaults.primary_staff_id = 1363;
                defaults.staff = [1363];
                defaults.groups = [];
                defaults.teams = [6];
                defaults.level_of_care = levelOfCare;
                defaults.etherapy_program = 2;
                instanceName = 'Available to Anthem KY Members';
                break;
            case 'wv-public':
                defaults.agency_guid = 'KF_fD3Y';
                defaults.entities = [7];
                defaults.primary_staff_id = 6967;
                defaults.staff = [6967];
                defaults.groups = [];
                defaults.teams = [8];
                defaults.etherapy_program = 2;
                instanceName = 'Available to West Virginia Members';
                showPayerName = true;
                break;
            case 'thrivepeersupport':
                defaults.agency_guid = 'KE_eyZa';
                defaults.entities = [46];
                defaults.primary_staff_id = 1220;
                defaults.staff = [2460, 2459, 1634, 1220];
                defaults.groups = [];
                defaults.teams = [6];
                defaults.level_of_care = levelOfCare;
                instanceName = 'Available to Thrive Members';
                break;
            case 'tugriver':
                defaults.agency_guid = 'KF_fD3Y';
                defaults.entities = [25];
                defaults.primary_staff_id = 623;
                defaults.staff = [623];
                defaults.groups = [];
                defaults.teams = [8];
                defaults.level_of_care = levelOfCare;
                defaults.etherapy_program = 2;
                instanceName = 'Available to Tug River Health Association Members';
                break;
            case 'f5project':
                defaults.agency_guid = 'KE_eyZa';
                defaults.entities = [58];
                defaults.primary_staff_id = 2041;
                defaults.staff = [2036, 2039, 2041];
                defaults.groups = [92];
                defaults.teams = [6, 93];
                defaults.etherapy_program = 2;
                instanceName = 'Available to F5 Project Members';
                break;
            case 'milehigh':
                defaults.agency_guid = 'K4_e5Ow';
                defaults.entities = [];
                defaults.primary_staff_id = 35;
                defaults.staff = [35];
                defaults.groups = [];
                defaults.teams = [];
                defaults.level_of_care = levelOfCare;
                instanceName = 'Available to Mile High Members';
                break;
            case 'wvslpublic':
                defaults.agency_guid = 'KF_fD3Y';
                defaults.entities = [64];
                defaults.primary_staff_id = 5314;
                defaults.staff = [5314];
                defaults.groups = [];
                defaults.teams = [8];
                defaults.etherapy_program = 2;
                instanceName = 'Available to WVSL Members';
                break;
        }
    }

    //check if QEL is for companion 
    companion = window.location.hostname.includes('companion.health');

    //change title of page based on patient or staff form
    if(!window.location.hostname.includes('enrollment')) {
        document.title = "Self Sign-Up Form";
    }

    return defaults;
}

const config = {
    api_url: process.env.VUE_APP_API_URL,
    community_url: process.env.VUE_APP_COMMUNITY_API,
    xref_url: process.env.VUE_APP_XREF_URL,
    defaults: getDefaults(),
    instance: instanceName,
    payer_name: showPayerName,
    companion: companion
}

export default config